const frontendURL = '/cat/contragent/';
const backendURL = '/api/references/refcontragent/';
const name = 'Контрагенти';

const instance = {
  frontendURL,
  backendURL,
  name,
  useHierarchyPagination: true,
};
export default instance;
